// extracted by mini-css-extract-plugin
export default {"lineButtons":"realEstateItem_lineButtons__mIn+l","headers":"realEstateItem_headers__S0sH1","twoInLine":"realEstateItem_twoInLine__dA61j"};